// Pathify
import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import { make } from 'vuex-pathify'

Vue.use(router)

// Data
const state = {
  comments: [],
}

const mutations = {
  ...make.mutations(state),
}

const actions = {
  ...make.actions(state),
  ADD_COMMENT ({ commit }, comment) {
    return new Promise((resolve, reject) => {
      axios.post('/api/comments', comment)
        .then(response => {
          resolve(response)
        }).catch(err => {
        reject(err)
      })
    })
  },
  GET_COMMENTS ({ commit }) {
    axios.get('/api/comments')
      .then(res => {
        // this.state.comments = res.data
      })
      .catch(err => {
        console.log(err)
      })
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
